import { render, staticRenderFns } from "./yous-wx.vue?vue&type=template&id=619037e3&scoped=true"
import script from "./yous-wx.vue?vue&type=script&lang=js"
export * from "./yous-wx.vue?vue&type=script&lang=js"
import style0 from "./yous-wx.vue?vue&type=style&index=0&id=619037e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619037e3",
  null
  
)

export default component.exports